import React, { useState, useEffect } from 'react'
import { Row, Col, Divider } from 'antd'
import { epagAPI } from '../../API/epagAPI'
import { useGetToken } from '../../hooks/useGetToken'
import {
  ProfileWrapper,
  CompanyProfile,
  HeaderProfileWrapper,
  EmployeeName,
  Line,
  AuditTableWrapper,
  AntTable,
  PreContainer,
  ActionButtons
} from './styles'
import { LoadingSpin } from '../LoadingSpin'
import { ErrorText } from '../EditProfile/Inputs/styles'
import { Text } from '../../constants/TextConstants'
import { useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { HeaderMenu } from '../HeaderMenu'
import { useSave } from '../../Context/saveContext'
import HeaderLinks from '../HeaderLinks'
import { useNavigateToWhenOwnView } from '../../utils/utils'
import { PERMISSION_CODES } from '../../constants/permissions'

export const Audit = (hideHeaderMenu = true) => {
  const { userId } = useParams()
  const isOwnProfile = !userId
  const [profileLogs, setProfileLogs] = useState([])
  const [ErrorFetch, setErrorFetch] = useState('')
  const { token } = useGetToken()
  const { userProfile, setIsLoading, isLoading, userPermissions, permissionsQuantity } = useSave()
  const navigate = useNavigate()
  useNavigateToWhenOwnView(userId, '/audit')

  const email = isOwnProfile ? userProfile?.email || '' : `${userId}@endava.com`

  useEffect(() => {
    setIsLoading(true)
    if (token && userProfile) {
      if (!isOwnProfile && !userPermissions.includes(PERMISSION_CODES.viewPeoplesAudit.code)) {
        navigate('/404')
      }
      epagAPI
        .GetProfileLogs(email)
        .then((answer) => {
          if (answer.code === 403) {
            navigate('/404')
          }
          const reversedProfileLogs = answer.data.logs.reverse()
          setProfileLogs(reversedProfileLogs)
          setIsLoading(false)
          setErrorFetch('')
        })
        .catch((error) => {
          setErrorFetch(error.message)
          setIsLoading(false)
        })
    }
  }, [token, userProfile, userId, permissionsQuantity])
  const toLocaleString = (text) => {
    const date = new Date(text)
    return date.toLocaleString()
  }
  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      ellipsis: true,
      defaultSortOrder: 'ascend',
      render: function toLocal(text) {
        return <>{toLocaleString(text)}</>
      }
    },
    { title: 'User', dataIndex: 'user', key: 'user', ellipsis: true },
    { title: 'Action Type', dataIndex: 'actionType', key: 'actionType', width: '20%', ellipsis: true }
  ]

  const AuditTable = () => {
    return (
      <AntTable
        style={{ maxWidth: '100vw', backgroundColor: 'transparent' }}
        columns={columns}
        size='small'
        rowKey='_id'
        expandable={{
          expandedRowRender: (record) => {
            return expandedContent(record)
          },

          rowExpandable: (record) => record.name !== 'Not Expandable'
        }}
        dataSource={profileLogs}
      />
    )
  }

  const RenderAudit = () => {
    return (
      <>
        {(userProfile || userId) && (
          <div data-testid='audit-container'>
            {!hideHeaderMenu && <HeaderMenu mail={email} defaultNavName={Text.Audit} hideEditButton={false} />}
            <ProfileWrapper>
              <CompanyProfile>Audit Logs</CompanyProfile>
              <HeaderProfileWrapper>
                <EmployeeName>{email}</EmployeeName>
                <ActionButtons>
                  {!isOwnProfile && userId && <HeaderLinks email={`${userId}@endava.com`} active={'audit'} />}
                </ActionButtons>
              </HeaderProfileWrapper>
              <Line />
              <AuditTableWrapper>
                <AuditTable />
              </AuditTableWrapper>
            </ProfileWrapper>
          </div>
        )}
        {userProfile.email !== '' && userProfile.name === '' ? <div>{Text.NotInfo}</div> : undefined}
      </>
    )
  }

  const expandedContent = (record) => (
    <>
      {Object.keys(record.description).map((key) => {
        return (
          <div key={key}>
            <Col className='expanded-row'>
              <Row className='gutter-row expanded-row__key'>
                <h2>{key}</h2>
              </Row>
              <Row className='expanded-row__value'>
                <Col className='gutter-row' span={12} xs={24} lg={12}>
                  <h3>Old value</h3>
                  <div style={{ maxWidth: '100%' }}>
                    {
                      // check if is an object
                      typeof record.description[key] === 'object' ? (
                        <PreContainer>
                          <pre>{JSON.stringify(record.description[key].old, null, '  ')}</pre>
                        </PreContainer>
                      ) : (
                        <p> {String(record.description[key].old)}</p>
                      )
                    }
                  </div>
                </Col>
                <Col className='gutter-row' span={12} xs={24} sm={12}>
                  <h3>New value</h3>
                  {
                    // check if is an object
                    typeof record.description[key] === 'object' ? (
                      <PreContainer>
                        <pre>{JSON.stringify(record.description[key].new, null, '  ')}</pre>
                      </PreContainer>
                    ) : (
                      <p> {String(record.description[key].new)}</p>
                    )
                  }
                </Col>
              </Row>
            </Col>
            <Divider />
          </div>
        )
      })}
    </>
  )
  Audit.propTypes = {
    route: PropTypes.object,
    navigation: PropTypes.object
  }

  return (
    <>
      {isLoading ? (
        <LoadingSpin loadingText={Text.GenericLoading} />
      ) : ErrorFetch !== '' ? (
        <ErrorText>{ErrorFetch}</ErrorText>
      ) : (
        RenderAudit()
      )}
    </>
  )
}
